'use strict';

import {apiClient, helpers} from "@zerolight/cloudmine-api-client";
const {clients, getClient, mergeCustomiser} = apiClient;
const {merge, mergeWith} = helpers;
import _ from 'lodash';
import {signOut} from './auth';

import {thenCallback} from './utils';

function apiCall(options, callback) {
	let p = apiClient.apiCall(options)
		.catch(function (err) {
			if (err instanceof apiClient.AuthError) {
				console.error('Redirecting to auth service');
				signOut();
			}
			throw err;
		});
	return thenCallback(p, callback);
}

function typesEqual(t1, t2) {
	let l = t1.length;
	if (l !== t2.length) {
		return false;
	}
	for (let i = 0; i < l; i++) {
		if (t1[i] !== t2[i]) {
			return false;
		}
	}
	return true;
}

class TypesMap {
	constructor(options) {
		this._data = new Map();
		this._options = Object.assign({}, options);
	}

	matchingType(type) {
		for (let t of this._data.keys()) {
			if (typesEqual(t, type)) {
				return t;
			}
		}
		return type;
	}

	get data() {
		return this._data;
	}

	setData(data) {
		for (let row of data) {
			let {type} = row;
			let matching = this.matchingType(type);
			if (matching) {
				row = Object.assign({}, row, {type: matching});
				this._data.set(matching, row);
			} else {
				row = Object.assign({}, row);
				this._data.set(type, row);
			}
		}
	}

	mergeData(data) {
		let customiser = this._options.mergeCustomiser;
		let m = customiser ? mergeWith.bind(null, customiser) : merge;
		for (let row of data) {
			let {type} = row;
			let matching = this.matchingType(type);
			if (matching) {
				let currentValue = this._data.get(matching);
				let mergedValue = m({}, currentValue, row, customiser);
				mergedValue.type = matching;
				this._data.set(matching, mergedValue);
			} else {
				row = Object.assign({}, row);
				this._data.set(type, row);
			}
		}
	}

	[Symbol.iterator]() {
		return this._data.entries();
	}

	get(type, field, def) {
		type = this.matchingType(type);
		let value = this._data.get(type);
		if (!_.isUndefined(value)) {
			if (!_.isUndefined(field)) {
				return _.get(value, field);
			} else {
				return value;
			}
		}
		return def;
	}
}

function eventTypesAPICall(options, callback) {
	options = Object.assign({merge: true}, options);
	let {type, params, merge, mergeCustomiser} = options;
	if (type) {
		params = Object.assign({}, params, {type});
	} else {
		type = params.type;
	}

	if (!type) {
		throw new Error('Event type is required');
	}

	let apiCallOptions = Object.assign({}, options, {merge: false, params});

	let p = apiCall(apiCallOptions)
		.then(function (responses) {
			if (!merge) {
				return responses;
			}
			let response = {};
			if (responses.error) {
				response.error = responses.error;
			}
			let data = new TypesMap({mergeCustomiser});
			for (let k of Object.keys(responses)) {
				let r = responses[k];
				if (r.hasOwnProperty('data')) {
					data.mergeData(r.data);
				}
			}
			response.data = data;
			return response;
		});

	return thenCallback(p, callback);
}


export {apiCall, TypesMap, eventTypesAPICall, mergeCustomiser, clients, getClient};